import { getEnvironmentProps } from "../../utils/environment";
import { dmnIdentity } from "../../utils/dmnIdentity";
import { errorHandler, apiFetchNotOkHandler } from "../errorHandler";
import { getBuildVersion } from "../getDefaultHeaders";

export const unlinkBooking = async (
  bookingId: string,
  linkedBookingId: string
): Promise<boolean> => {
  const token = await dmnIdentity.getAccessToken();
  const environmentVars = getEnvironmentProps(token);

  try {
    const response = await fetch(
      `${environmentVars?.COLLINS_API_BASE_URL}/bookings/${bookingId}/linked/${linkedBookingId}`,
      {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${token}`,
          "X-Build-Version": getBuildVersion()
        }
      }
    );

    if (response.ok) {
      return true;
    }

    apiFetchNotOkHandler(response, "Error unlinking booking");
    return false;
  } catch (error) {
    errorHandler(error, "Error unlinking booking");
    return false;
  }
};
